import React, { Component } from 'react';
import moment from 'moment';
import ReactToPrint from "react-to-print";
import networkList from '../../../constants/networkList';
// import { addonSchema } from './../../../schema/cash-medical-estimate-table';
// import Tableantd from './../../../form_component/table/antd';
const {homepage} = networkList;
class Fc_Patient_copy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            'printData': { 'payment_type': 'Cash', 'care_management': 'Medical', estimate_type: 'non_package' },
            'addonSchema': [{
                "id": 1,
                "title": "Room charges",
                "amount": 1200,
                "details": [{
                    "id": 1,
                    "service_name": "room",
                    "qty": 2,
                    "rate": 100,
                    "amount": 200
                }, {
                    "id": 2,
                    "service_name": "icu",
                    "qty": 1,
                    "rate": 1000,
                    "amount": 1000
                }]
            }, {
                "id": 2,
                "title": "Room Investigation Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "Routine",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "Highend",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }, {
                    "id": 3,
                    "service_name": "Highend",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 3,
                "title": "icu Investigation Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "Routine",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "Highend",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }, {
                    "id": 3,
                    "service_name": "Highend",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 4,
                "title": "IP Pharmacy Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "Routine Drugs & Implants",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "Highend Drugs & Implants",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }, {
                    "id": 3,
                    "service_name": "Highend Drugs & Implants",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 5,
                "title": "icu Pharmacy Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "Routine Drugs & Implants",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "Highend Drugs & Implants",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }, {
                    "id": 3,
                    "service_name": "Highend Drugs & Implants",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 6,
                "title": "OT/Cath Pharmacy",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "Routine",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "Highend",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 7,
                "title": "Drug Admin Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "Routine",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "Highend",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 7,
                "title": "General Equipment Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "Routine Equipment",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "Highend Equipment",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 8,
                "title": "OT Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "OT Hours",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 2,
                    "service_name": "OT Instruments",
                    "qty": 1,
                    "rate": 2000,
                    "amount": 2000
                }]
            }, {
                "id": 9,
                "title": "OT Equipment",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "OT equipment",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }]
            }, {
                "id": 10,
                "title": "Procedure Charges",
                "amount": 500,
                "details": [{
                    "id": 1,
                    "service_name": "Procedure name",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }]
            }, {
                "id": 10,
                "title": "Blood Bank Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "SS blood bank",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 1,
                    "service_name": "SS blood bank",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }]
            }, {
                "id": 11,
                "title": "Cross Consultation Charges",
                "amount": 4500,
                "details": [{
                    "id": 1,
                    "service_name": "name",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }]
            }, {
                "id": 12,
                "title": "Hospital Services",
                "amount": 1000,
                "details": [{
                    "id": 1,
                    "service_name": "MRD",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 1,
                    "service_name": "seropositive",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }]
            }, {
                "id": 13,
                "title": "Isolation Charges",
                "amount": 1000,
                "details": [{
                    "id": 1,
                    "service_name": "room",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 1,
                    "service_name": "ICU",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }]
            }, {
                "id": 14,
                "title": "Physiotherapy & Diet Charges",
                "amount": 1000,
                "details": [{
                    "id": 1,
                    "service_name": "dietican",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }, {
                    "id": 1,
                    "service_name": "physiotherapy",
                    "qty": 1,
                    "rate": 500,
                    "amount": 500
                }]
            }, {
                "id": 15,
                "title": "Professional Fees",
                "amount": 1000,
                "details": [{
                    "id": 1,
                    "service_name": "name",
                    "qty": 1,
                    "rate": 1000,
                    "amount": 1000
                }]
            }, {
                "id": 15,
                "title": "Medical Charges",
                "amount": 4000,
                "details": [{
                    "id": 1,
                    "service_name": "Physician Fees",
                    "qty": 1,
                    "rate": 1000,
                    "amount": 1000
                }, {
                    "id": 1,
                    "service_name": "Asst Physician Fees",
                    "qty": 1,
                    "rate": 1000,
                    "amount": 1000
                }, {
                    "id": 1,
                    "service_name": "Intensivist",
                    "qty": 1,
                    "rate": 1000,
                    "amount": 1000
                }, {
                    "id": 1,
                    "service_name": "Asst Intensivist",
                    "qty": 1,
                    "rate": 1000,
                    "amount": 1000
                }]
            }]

        }
    }

    componentDidMount() {
        window.scrollTo({
            top: 50,
            left: 0,
            behavior: 'smooth'
        });
        let print_response = null;
        let user_data = null;
        if (localStorage.getItem('print_response') !== null) {
            print_response = JSON.parse(localStorage.getItem('print_response'));
            user_data = JSON.parse(localStorage.getItem('user_data'));
            this.setState((state) => ({ 'printData': print_response[0], 'user_data': user_data }))
        }
    }

    cancel() {
        this
            .props
            .history
            .push(`/counselling/counsellor-view`);
        localStorage.removeItem("print_response");
    }

    onChange(checked) {
        console.log(`switch to ${checked}`);
    }
    print = () => {
        document.getElementById("myH1").style.margin = "-130px 0px 0px 0px";
        window.print();
        document.getElementById("myH1").style.margin = "0px";
    }
    cancelPrint() {
        this.props.cancel()
    }
    render() {
        let { printData, user_data, addonSchema, words } = this.state;
        return (
            <React.Fragment >
                <div ref={(el) => (this.componentRef = el)} >
                    {/* cash medical non package */}
                    {(printData['payment_type'] && printData['payment_type'] === 'Cash' && printData['care_management'] === 'Medical' && printData['estimate_type'] === 'non_package') && <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix">
                                    <img src={`${homepage}/assets/images/units-logo/${user_data["unitid"]&&user_data["unitid"]}.png`} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                                </div>

                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(printData['counselling_date']).format('YYYY-MM-DD')}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {printData['counselling_type'] || printData['counselling_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">UMR number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {printData['patient_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone</span>
                                            <span className="w-100">: {printData['patient_mobile']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {printData['patient_age']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Doctor Name</span>
                                            <span className="w-100">: {printData['doctor_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {printData['doctor_speciality']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {printData['care_management_value'] || printData['care_management']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {printData['estimate_value'] || printData['estimate_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Mode of Payment</span>
                                            <span className="w-100">: {printData['payment_type'] || printData['payment_type_value']}</span>
                                        </div>
                                    </div>

                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {printData['room_opted_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Eligibility Ward</span>
                                            <span className="w-100">: {printData['room_eligible_ward_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Tariff</span>
                                            <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {printData['estimated_date_of_admission']}</span>
                                        </div>
                                    </div>


                                </div>
                                <React.Fragment>
                                    <div className="py-2 mt-5 border estimate-table">
                                        <div className="row px-3">
                                            <div className="col-6">
                                                <h4 className="mb-0">service name</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Quantity</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">rate</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">amount</h4>
                                            </div>
                                        </div>
                                        <hr />
                                        {addonSchema.map((feild, key) => {
                                            console.log('addonschema:', feild)
                                            return (<React.Fragment key={key}>
                                                <div className="row px-3">
                                                    <div className="col-10">
                                                        <h6 className="mb-0">{feild.title}</h6>
                                                    </div>
                                                    <div className="col-2">
                                                        <h6 className="mb-0">{feild.amount}</h6>
                                                    </div>
                                                </div>
                                                <div className="pb-4">
                                                    {feild.details.map((feild2, key) => {
                                                        return (<React.Fragment>
                                                            <div className="row px-3">
                                                                <div className="col-6">
                                                                    <p className="mb-0">{feild2.service_name ? feild2.service_name : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">{feild2.qty ? feild2.qty : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">*</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.rate ? feild2.rate : ''}</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.amount ? feild2.amount : ''}</p>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>)
                                                    })}
                                                </div>
                                            </React.Fragment>)
                                        })}

                                        <div className="row py-4 px-3">
                                            <div className="col-10">
                                                <h4 className="mb-0">Total Estimated Amount:</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Rs.</h4>
                                            </div>
                                        </div>
                                    </div>

                                </React.Fragment>
                            </div>
                        </div>
                    </React.Fragment>
                    }
                    {/* cash surgery package */}
                    {(printData['payment_type'] && printData['payment_type'] === 'Cash' && printData['care_management'] === 'Surgery' && printData['estimate_type'] === 'package') && <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix pt-5">
                                    <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                                </div>

                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(printData['counselling_date']).format('YYYY-MM-DD')}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {printData['counselling_type'] || printData['counselling_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">UMR number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {printData['patient_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone</span>
                                            <span className="w-100">: {printData['patient_mobile']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {printData['patient_age']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Doctor Name</span>
                                            <span className="w-100">: {printData['doctor_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {printData['doctor_speciality']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {printData['care_management_value'] || printData['care_management']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {printData['estimate_value'] || printData['estimate_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Mode of Payment</span>
                                            <span className="w-100">: {printData['payment_type'] || printData['payment_type_value']}</span>
                                        </div>
                                    </div>

                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>

                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {printData['room_opted_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Eligibility Ward</span>
                                            <span className="w-100">: {printData['room_eligible_ward_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Surgery</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-8">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery/Procedure</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-8">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Additional Surgery</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                  
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {printData['estimated_date_of_admission']}</span>
                                        </div>
                                    </div>


                                </div>
                                <React.Fragment>
                                    <div className="p-2 mt-5 border estimate-table">
                                        <div className="row px-3">
                                            <div className="col-6">
                                                <h4 className="mb-0">service name</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Quantity</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">rate</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">amount</h4>
                                            </div>
                                        </div>
                                        <hr />
                                        {addonSchema.map((feild, key) => {
                                            console.log('addonschema:', feild)
                                            return (<React.Fragment key={key}>
                                                <div className="clearfix px-2">
                                                    <span className="float-left">
                                                        <h6 className="mb-0">{feild.title}</h6>
                                                    </span>
                                                    <span className="float-right">
                                                        <h6 className="mb-0">{feild.amount}</h6>
                                                    </span>
                                                </div>
                                                <div className="pb-4">
                                                    {feild.details.map((feild2, key) => {
                                                        return (<React.Fragment>
                                                            <div className="row px-3">
                                                                <div className="col-6">
                                                                    <p className="mb-0">{feild2.service_name ? feild2.service_name : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">{feild2.qty ? feild2.qty : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">*</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.rate ? feild2.rate : ''}</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.amount ? feild2.amount : ''}</p>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>)
                                                    })}
                                                </div>
                                            </React.Fragment>)
                                        })}

                                        <div className="clearfix py-4">
                                            <span className="float-left">
                                                <h4 className="mb-0">Total Estimated Amount:</h4>
                                            </span>
                                            <span className="float-right">
                                                <h4 className="mb-0">Rs. {printData['total_estimate_amount']}</h4>
                                            </span>
                                        </div>
                                    </div>
                                </React.Fragment>
                            </div>
                        </div>
                    </React.Fragment>
                    }
                    {/* cash surgery non package */}
                    {(printData['payment_type'] && printData['payment_type'] === 'Cash' && printData['care_management'] === 'Surgery' && printData['estimate_type'] === 'non_package') && <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix pt-5">
                                    <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                                </div>

                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(printData['counselling_date']).format('YYYY-MM-DD')}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {printData['counselling_type'] || printData['counselling_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">UMR number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {printData['ip']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {printData['patient_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone</span>
                                            <span className="w-100">: {printData['patient_mobile']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {printData['patient_age']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Doctor Name</span>
                                            <span className="w-100">: {printData['doctor_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {printData['doctor_speciality']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {printData['care_management_value'] || printData['care_management']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {printData['estimate_value'] || printData['estimate_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Mode of Payment</span>
                                            <span className="w-100">: {printData['payment_type'] || printData['payment_type_value']}</span>
                                        </div>
                                    </div>

                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>

                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {printData['room_opted_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Eligibility Ward</span>
                                            <span className="w-100">: {printData['room_eligible_ward_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Tariff</span>
                                            <span className="w-100">: {printData['lenght_of_stay']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-8">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery/Procedure</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Additional Surgery</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Surgery</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {printData['estimated_date_of_admission']}</span>
                                        </div>
                                    </div>


                                </div>
                                <React.Fragment>
                                    <div className="p-2 mt-5 border estimate-table">
                                        <div className="row px-3">
                                            <div className="col-6">
                                                <h4 className="mb-0">service name</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Quantity</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">rate</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">amount</h4>
                                            </div>
                                        </div>
                                        <hr />
                                        {addonSchema.map((feild, key) => {
                                            console.log('addonschema:', feild)
                                            return (<React.Fragment key={key}>
                                                <div className="clearfix px-2">
                                                    <span className="float-left">
                                                        <h6 className="mb-0">{feild.title}</h6>
                                                    </span>
                                                    <span className="float-right">
                                                        <h6 className="mb-0">{feild.amount}</h6>
                                                    </span>
                                                </div>
                                                <div className="pb-4">
                                                    {feild.details.map((feild2, key) => {
                                                        return (<React.Fragment>
                                                            <div className="row px-3">
                                                                <div className="col-6">
                                                                    <p className="mb-0">{feild2.service_name ? feild2.service_name : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">{feild2.qty ? feild2.qty : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">*</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.rate ? feild2.rate : ''}</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.amount ? feild2.amount : ''}</p>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>)
                                                    })}
                                                </div>
                                            </React.Fragment>)
                                        })}

                                        <div className="clearfix py-4">
                                            <span className="float-left">
                                                <h4 className="mb-0">Total Estimated Amount:</h4>
                                            </span>
                                            <span className="float-right">
                                                <h4 className="mb-0">Rs. {printData['total_estimate_amount']}</h4>
                                            </span>
                                        </div>
                                    </div>

                                </React.Fragment>
                            </div>
                        </div>
                    </React.Fragment>
                    }
                    {/* Insurance medical non package */}
                    {(printData['payment_type'] && printData['payment_type'] === 'Insurance' && printData['care_management'] === 'Medical' && printData['estimate_type'] === 'non_package') && <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix pt-5">
                                    <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                                </div>

                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(printData['counselling_date']).format('YYYY-MM-DD')}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {printData['counselling_type'] || printData['counselling_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">UMR number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {printData['patient_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone</span>
                                            <span className="w-100">: {printData['patient_mobile']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {printData['patient_age']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Doctor Name</span>
                                            <span className="w-100">: {printData['doctor_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {printData['doctor_speciality']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {printData['care_management_value'] || printData['care_management']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {printData['estimate_value'] || printData['estimate_value']}</span>
                                        </div>
                                    </div>                                   
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Mode of Payment</span>
                                            <span className="w-100">: {printData['payment_type'] || printData['payment_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Insurance Name </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">TPA Name </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Pre Auth Status </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>

                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {printData['room_opted_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Eligibility Ward</span>
                                            <span className="w-100">: {printData['room_eligible_ward_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU Eligibility</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {printData['estimated_date_of_admission']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Sum Insured </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Balance</span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Ailment Capping </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Co-pay </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>


                                </div>
                                <React.Fragment>
                                    <div className="py-2 mt-5 border estimate-table">
                                        <div className="row px-3">
                                            <div className="col-6">
                                                <h4 className="mb-0">service name</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Quantity</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">rate</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">amount</h4>
                                            </div>
                                        </div>
                                        <hr />
                                        {addonSchema.map((feild, key) => {
                                            console.log('addonschema:', feild)
                                            return (<React.Fragment key={key}>
                                                <div className="row px-3">
                                                    <div className="col-10">
                                                        <h6 className="mb-0">{feild.title}</h6>
                                                    </div>
                                                    <div className="col-2">
                                                        <h6 className="mb-0">{feild.amount}</h6>
                                                    </div>
                                                </div>
                                                <div className="pb-4">
                                                    {feild.details.map((feild2, key) => {
                                                        return (<React.Fragment>
                                                            <div className="row px-3">
                                                                <div className="col-6">
                                                                    <p className="mb-0">{feild2.service_name ? feild2.service_name : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">{feild2.qty ? feild2.qty : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">*</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.rate ? feild2.rate : ''}</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.amount ? feild2.amount : ''}</p>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>)
                                                    })}
                                                </div>
                                            </React.Fragment>)
                                        })}

                                        <div className="row py-4 px-3">
                                            <div className="col-10">
                                                <h4 className="mb-0">Total Estimated Amount:</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Rs.</h4>
                                            </div>
                                        </div>
                                    </div>

                                </React.Fragment>
                                <div className="row m-0 mt-5 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Co-pay </span>
                                            <span className="w-100">:</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">NME </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room upgrade charges</span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Difference Amount </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Total </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </React.Fragment>
                    }
                    {/* Insurance surgery package */}
                    {(printData['payment_type'] && printData['payment_type'] === 'Insurance' && printData['care_management'] === 'Surgery' && printData['estimate_type'] === 'package') && <React.Fragment>
                        <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix pt-5">
                                    <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                                </div>

                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(printData['counselling_date']).format('YYYY-MM-DD')}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {printData['counselling_type'] || printData['counselling_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">UMR number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {printData['patient_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone</span>
                                            <span className="w-100">: {printData['patient_mobile']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {printData['patient_age']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Doctor Name</span>
                                            <span className="w-100">: {printData['doctor_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {printData['doctor_speciality']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {printData['care_management_value'] || printData['care_management']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {printData['estimate_value'] || printData['estimate_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Mode of Payment</span>
                                            <span className="w-100">: {printData['payment_type'] || printData['payment_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Insurance Name </span>
                                            <span className="w-100">: {printData[''] || printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">TPA Name </span>
                                            <span className="w-100">: {printData[''] || printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery/Package Name </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of surgery </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {printData['room_opted_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Eligibility Ward</span>
                                            <span className="w-100">: {printData['room_eligible_ward_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU Eligibility</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-8">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery/Procedure</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Surgery</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {printData['estimated_date_of_admission']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Sum Insured </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Balance</span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Ailment Capping </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Co-pay </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>

                                </div>
                                <React.Fragment>
                                    <div className="p-2 mt-5 border estimate-table">
                                        <div className="row px-3">
                                            <div className="col-6">
                                                <h4 className="mb-0">service name</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Quantity</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">rate</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">amount</h4>
                                            </div>
                                        </div>
                                        <hr />
                                        {addonSchema.map((feild, key) => {
                                            console.log('addonschema:', feild)
                                            return (<React.Fragment key={key}>
                                                <div className="clearfix px-2">
                                                    <span className="float-left">
                                                        <h6 className="mb-0">{feild.title}</h6>
                                                    </span>
                                                    <span className="float-right">
                                                        <h6 className="mb-0">{feild.amount}</h6>
                                                    </span>
                                                </div>
                                                <div className="pb-4">
                                                    {feild.details.map((feild2, key) => {
                                                        return (<React.Fragment>
                                                            <div className="row px-3">
                                                                <div className="col-6">
                                                                    <p className="mb-0">{feild2.service_name ? feild2.service_name : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">{feild2.qty ? feild2.qty : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">*</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.rate ? feild2.rate : ''}</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.amount ? feild2.amount : ''}</p>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>)
                                                    })}
                                                </div>
                                            </React.Fragment>)
                                        })}

                                        <div className="clearfix py-4">
                                            <span className="float-left">
                                                <h4 className="mb-0">Total Estimated Amount:</h4>
                                            </span>
                                            <span className="float-right">
                                                <h4 className="mb-0">Rs. {printData['total_estimate_amount']}</h4>
                                            </span>
                                        </div>
                                    </div>
                                </React.Fragment>
                                <div className="row m-0 mt-5 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Co-pay </span>
                                            <span className="w-100">:</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">NME </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room upgrade charges</span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Difference Amount </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Total </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    }
                    {/* Insurance surgery non package */}
                    {(printData['payment_type'] && printData['payment_type'] === 'Insurance' && printData['care_management'] === 'Surgery' && printData['estimate_type'] === 'non_package') && <React.Fragment>
                    <div className="fc-patient-copy">
                            <div className="p-4 bg-white" id="myH1">
                                <div className="clearfix pt-5">
                                    <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                                    <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                                </div>

                                <div>
                                    <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                                </div>
                                <div className="row m-0 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of Counselling</span>
                                            <span className="w-100">: {moment(printData['counselling_date']).format('YYYY-MM-DD')}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Counselling type</span>
                                            <span className="w-100">: {printData['counselling_type'] || printData['counselling_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">UMR number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">IP number</span>
                                            <span className="w-100">: {printData['umr']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Name</span>
                                            <span className="w-100">: {printData['patient_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Phone</span>
                                            <span className="w-100">: {printData['patient_mobile']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Patient Age</span>
                                            <span className="w-100">: {printData['patient_age']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Doctor Name</span>
                                            <span className="w-100">: {printData['doctor_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Specialty</span>
                                            <span className="w-100">: {printData['doctor_speciality']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Care Management</span>
                                            <span className="w-100">: {printData['care_management_value'] || printData['care_management']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimate Type</span>
                                            <span className="w-100">: {printData['estimate_value'] || printData['estimate_value']}</span>
                                        </div>
                                    </div>                                   
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Mode of Payment</span>
                                            <span className="w-100">: {printData['payment_type'] || printData['payment_type_value']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Insurance Name </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">TPA Name </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Pre Auth Status </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Surgery/Package Name </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Date of surgery </span>
                                            <span className="w-100">: {printData['Insurance Name '] || printData['Insurance Name ']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Length of Stay </span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU</span>
                                            <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                                        </div>
                                    </div>

                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Opted</span>
                                            <span className="w-100">: {printData['room_opted_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Eligibility Ward</span>
                                            <span className="w-100">: {printData['room_eligible_ward_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Upgrade Reason</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU Eligibility</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">ICU Upgrade</span>
                                            <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Estimated Date of Admission</span>
                                            <span className="w-100">: {printData['estimated_date_of_admission']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Sum Insured </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Balance</span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Ailment Capping </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Co-pay </span>
                                            <span className="w-100">: {printData['']}</span>
                                        </div>
                                    </div>


                                </div>
                                <React.Fragment>
                                    <div className="py-2 mt-5 border estimate-table">
                                        <div className="row px-3">
                                            <div className="col-6">
                                                <h4 className="mb-0">service name</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Quantity</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">rate</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">amount</h4>
                                            </div>
                                        </div>
                                        <hr />
                                        {addonSchema.map((feild, key) => {
                                            console.log('addonschema:', feild)
                                            return (<React.Fragment key={key}>
                                                <div className="row px-3">
                                                    <div className="col-10">
                                                        <h6 className="mb-0">{feild.title}</h6>
                                                    </div>
                                                    <div className="col-2">
                                                        <h6 className="mb-0">{feild.amount}</h6>
                                                    </div>
                                                </div>
                                                <div className="pb-4">
                                                    {feild.details.map((feild2, key) => {
                                                        return (<React.Fragment>
                                                            <div className="row px-3">
                                                                <div className="col-6">
                                                                    <p className="mb-0">{feild2.service_name ? feild2.service_name : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">{feild2.qty ? feild2.qty : ''}</p>
                                                                </div>
                                                                <div className="col-1">
                                                                    <p className="mb-0">*</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.rate ? feild2.rate : ''}</p>
                                                                </div>
                                                                <div className="col-2">
                                                                    <p className="mb-0">{feild2.amount ? feild2.amount : ''}</p>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>)
                                                    })}
                                                </div>
                                            </React.Fragment>)
                                        })}

                                        <div className="row py-4 px-3">
                                            <div className="col-10">
                                                <h4 className="mb-0">Total Estimated Amount:</h4>
                                            </div>
                                            <div className="col-2">
                                                <h4 className="mb-0">Rs.</h4>
                                            </div>
                                        </div>
                                    </div>

                                </React.Fragment>
                                <div className="row m-0 mt-5 pb-3 border">
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Co-pay </span>
                                            <span className="w-100">:</span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">NME </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Room upgrade charges</span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Difference Amount </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                    <div className="col-4 ">
                                        <div className="d-inline-flex">
                                            <span className="w-label">Total </span>
                                            <span className="w-100">: </span>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </React.Fragment>
                    }

                    <div className="insurance p-4 bg-white">
                        <h5 className="data-label w-100">Declaration:</h5>
                        <p className="one text-justify">I hereby accept that all the above tariff and breakup was explained to me/us in a language I/We understand in detail. I understand that the
                        amount quoted is only an estimate and the actual charges incurred at the time of the final bill may vary. I take full responsibility of clearing
                        all dues payable to the hospital by arranging payment either by myself or through immediate family of the patient, at the time of discharge / leaving the hospital.</p>
                        <div className="clearfix pt-4">
                            <span className="float-left">
                                Signature: ____________________
                            </span>
                            <span className="float-right">
                                Signature: ____________________
                            </span>
                        </div>
                        <div className="clearfix pt-4 pb-4">
                            <span className="float-left">
                                Patient/Attendant Name: ____________________
                            </span>
                            <span className="float-right">
                                Financial Counsellor: {printData['counsellor_name']} ({user_data ? user_data['kims_userid'] ? user_data['kims_userid'] : '--' : '--'})
                            </span>
                        </div>

                    </div>

                </div>
                <div className="fc-patient-copy">
                    <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                        <ReactToPrint
                            // trigger={() => <a href="#">Print this out!</a>}
                            trigger={() => <button className="btn btn-success d-print-none text-capitalize">Print</button>}
                            content={() => this.componentRef}
                        />
                        <button className="btn btn-success d-print-none btn-next text-capitalize ml-3" onClick={this.cancelPrint.bind(this)}>cancel</button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Fc_Patient_copy;